import { render } from "./PurchaseReturnList.vue?vue&type=template&id=f871959a&scoped=true"
import script from "./PurchaseReturnList.vue?vue&type=script&lang=js"
export * from "./PurchaseReturnList.vue?vue&type=script&lang=js"

import "./PurchaseReturnList.vue?vue&type=style&index=0&id=f871959a&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f871959a"]])

export default __exports__